export default __webpack_public_path__ + "static/imagem-da-igreja-7c39814d083a18fd93544de39c00102b.png";